<template>
  <div>
    <ts-card-wrapper>
      <div class="ts-flex">
        <div class="ts-flex justify-content-start">
          <label class="mt-2 mr-1">{{ $t('cardToBePrint.type') }}</label>
          <select class="form-control" v-model="type">
            <option
              v-for="(type, index) in types"
              :key="index"
              :value="type.value"
              >{{ type.description }}</option
            >
          </select>
        </div>
        <div
          class="ml-2 ts-rounded ts-border ts-px-2 ts-whitespace-no-wrap"
          style="width:245px"
        >
          <div class="radio radio-css radio-inline m-t-1">
            <input v-model="side" type="radio" id="front" :value="1" />
            <label for="front">{{ $t('cardToBePrint.front') }}</label>
          </div>
          <div class="radio radio-css radio-inline">
            <input v-model="side" type="radio" id="back" :value="2" />
            <label for="back">{{ $t('cardToBePrint.back') }}</label>
          </div>
          <ts-button
            :disabled="type == 'All' || !checkedProfiles.length > 0"
            class="btn-sm ml-2 mr-2"
            outline
            color="primary"
            >{{ $t('cardToBePrint.previewCard') }}</ts-button
          >
        </div>
        <div class="ts-flex-grow"></div>
        <ts-input
          v-model="search"
          :placeholder="$t('search')"
          style="width: 300px;"
        />
        <ts-button
          outline
          class="ml-2"
          v-tooltip="$t('filter')"
          @click.prevent="visible = true"
        >
          <i class="fa fa-filter"></i>
        </ts-button>
      </div>
      <small>{{ $t('cardToBePrint.noteYouOnlyCanCheckOnePagination') }}</small>
    </ts-card-wrapper>
    <div class="overflow-auto">
      <ts-table
        :records="resources"
        :columns="columns"
        :loading="loading"
        :rowGroup="{
          field: 'branch'
        }"
        :showCheckbox="true"
        @check-items="checkItem"
      >
        <template v-slot="{ record }">
          <td class="with-img">
            <img
              class="height-30 ts-rounded"
              v-lazy="{
                src: photoStudent(record),
                error: onError(),
                loading: require('@/assets/Rolling-1s-200px_2.svg')
              }"
            />
          </td>
          <td class="ts-whitespace-no-wrap text-center">
            {{ record.card_number }}
          </td>
          <td class="ts-whitespace-no-wrap">{{ record.full_name }}</td>
          <td class="ts-whitespace-no-wrap text-center">
            {{ record.relationship }}
          </td>
        </template>
      </ts-table>
    </div>
    <div class="d-flex justify-content-between align-items-center p-15">
      <ts-total-list v-model="pagination" />
      <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
    </div>
    <a-drawer
      :title="$t('filter')"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="() => (visible = false)"
      :zIndex="1020"
      width="300px"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <ts-branch-filter @filter="value => (branch_id = value)" />
          </div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce, isEmpty } from 'lodash'

export default {
  name: 'newProfile',
  data() {
    return {
      loading: false,
      visible: false,
      side: 1,
      type: 'All',
      branch_id: [],
      checkedProfiles: [],
      defaultPhoto: require('../../assets/user_default.png'),
      types: [
        {
          value: 'All',
          description: 'All'
        },
        {
          value: 'Student',
          description: 'Student'
        },
        {
          value: 'Father',
          description: 'Father'
        },
        {
          value: 'Mother',
          description: 'Mother'
        },
        {
          value: 'Other',
          description: 'Other'
        }
      ]
    }
  },
  computed: {
    ...mapState('cardToBePrint/newProfile', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.cardToBePrint.newProfile.search
      },
      set(newValue) {
        this.$store.commit('cardToBePrint/newProfile/SET_SEARCH', newValue)
        this.$store.commit('cardToBePrint/newProfile/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('cardToBePrint.photo')
        },
        {
          name: this.$t('cardToBePrint.cardNumber'),
          sortKey: 'card_number',
          style: 'text-align:center'
        },
        {
          name: this.$t('cardToBePrint.studentOrGuardian'),
          sortKey: 'full_name'
        },
        {
          name: this.$t('cardToBePrint.relationship'),
          sortKey: 'relationship',
          style: 'text-align:center'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'cardToBePrint/newProfile/fetch',
          Object.assign(
            {},
            { type: this.type },
            { branch_id: this.branch_id },
            attributes
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    photoStudent(record) {
      if (record.photo) {
        return '/api/files?filePath=' + record.photo
      }

      return this.defaultPhoto
    },

    onError() {
      event ? (event.target.src = this.defaultPhoto) : ''
    },
    checkItem(value) {
      this.checkedProfiles = []
      if (!isEmpty(value)) {
        value.forEach(el => {
          this.checkedProfiles.push(el.object_id)
        })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    branch_id: debounce(function(value) {
      this.fetchData({ branch_id: value })
    }, 500),
    type: debounce(function(value) {
      this.fetchData({ type: value })
    }, 500)
  }
}
</script>
